import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditHttpNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditHttpNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditHttpNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
   ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export  const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [ 'url', 'data_management' ],
    properties: {
        'url': {
            title: "URL",
            type: 'string'
        },
        'method': {
            title: "Method",
            type: 'string',
            enum: [
                'GET',
                'POST',
                'PATCH'
            ],
            default: 'GET'
        },
        authorisation: {
            title: "Authorisation",
            type: 'string',
            enum: [
                'No Auth',
                'Bearer',
                'Basic'
            ],
            default: 'No Auth'
        },
        headers: {
            title: "Headers",
            type: 'array',
            items: {
                title: '',
                type: 'object',
                properties: {
                    key: {
                        title: "Key",
                        type: 'string'
                    },
                    value: {
                        title: "Value",
                        type: 'string'
                    },
                    description: {
                        title: "Description",
                        type: 'string'
                    }
                }
            }
        },
        body: {
            title: "Body",
            type: 'string',
            enum: [
                'None',
                'Form-Data',
                'X-WWW-Form-Urlencoded',
                'Raw',
                'GraphQL',
                'JSON'
            ],
            default: 'None'
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Select the data store to store the response data if applicable',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    body: {
                        const: 'GraphQL'
                    }
                }
            },
            then: {
                properties: {
                    graphql_query: {
                        title: 'Query',
                        type: 'string'
                    },
                    graphql_query_params: {
                        title: 'Query Params',
                        type: 'string'
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    body: {
                        const: 'Raw'
                    }
                }
            },
            then: {
                properties: {
                    raw_body: {
                        title: 'Raw Body',
                        type: 'string'
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    body: {
                        const: 'JSON'
                    }
                }
            },
            then: {
                properties: {
                    json_body: {
                        title: 'JSON',
                        type: 'string'
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    body: {
                        const: 'Form-Data'
                    }
                }
            },
            then: {
                properties: {
                    form_data: {
                        title: 'Form Data',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                key: {
                                    title: "Key",
                                    type: 'string'
                                },
                                value: {
                                    title: "Value",
                                    type: 'string'
                                },
                                description: {
                                    title: "Description",
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    body: {
                        const: 'X-WWW-Form-Urlencoded'
                    }
                }
            },
            then: {
                properties: {
                    form_urlencoded: {
                        title: 'X-WWW Form Urlencoded',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                key: {
                                    title: "Key",
                                    type: 'string'
                                },
                                value: {
                                    title: "Value",
                                    type: 'string'
                                },
                                description: {
                                    title: "Description",
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    'method': {
                        const: 'GET'
                    }
                }
            },
            then: {
                properties: {
                    query_params: {
                        title: 'Query Params',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                key: {
                                    title: "Key",
                                    type: 'string'
                                },
                                value: {
                                    title: "Value",
                                    type: 'string'
                                },
                                description: {
                                    title: "Description",
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    'authorisation': {
                        const: 'Basic'
                    }
                }
            },
            then: {
                properties: {
                    username: {
                        title: 'Username',
                        type: 'string'
                    },
                    password: {
                        title: 'Password',
                        type: 'string'
                    }
                },
                required: [ 'username', 'password' ]
            }
        },
        {
            if: {
                properties: {
                    'authorisation': {
                        const: 'Bearer'
                    }
                }
            },
            then: {
                properties: {
                    token: {
                        title: 'Token',
                        type: 'string'
                    },
                },
                required: [ 'token' ]
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to make an HTTP request to a third party API.\n" +
    "The response data will be stored in the Data Store slot for the next node.";